import React, { Component } from 'react';
import ComponentIcon from '@material-ui/icons/CloudDownload';

class CloudDownloadIcon extends Component {
  render() {
    const { color, ...rest } = this.props;
    return (
      <ComponentIcon
        {...rest}
        style={{ color: color}}
      />
    );
  }
}

export default CloudDownloadIcon;
